import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { siteData } from "../../data/siteData";
import "./Navbar.css";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="container navbar__inner">
        <a href="#home" className="navbar__logo">
          <div className="navbar__logo-leaf">🌿</div>
          <div className="navbar__company">
            <div className="navbar__logo-name">Gemburin</div>
            <div className="navbar__logo-sub">Sejahtera</div>
          </div>
        </a>

        <ul className={`navbar__links ${menuOpen ? "navbar__links--open" : ""}`}>
          {siteData.nav.map((item) => (
            <li key={item.href}>
              <a href={item.href} onClick={() => setMenuOpen(false)}>{item.label}</a>
            </li>
          ))}
        </ul>

        <a href={`tel:${siteData.company.phone}`} className="btn btn-green navbar__cta">
          <Phone size={15} /> Hubungi Kami
        </a>

        <button className="navbar__burger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </nav>
  );
}
